import { Component, computed, input } from '@angular/core';
import { Offer, OfferType } from '../../models/offers.model';

@Component({
  selector: 'app-offers-card',
  templateUrl: './offers-card.component.html',
  styleUrls: ['./offers-card.component.scss'],
  standalone: false,
})
export class OffersCardComponent {
  readonly isInCarousel = input<boolean>(false);
  readonly offer = input.required<Offer>();

  readonly isResumeAppOffer = computed(() => this.offer().offerType === OfferType.RESUME_APPLICATION);
  readonly isLoanOffer = computed(() => this.offer().productType !== 'CREDIT_CARD');
  readonly isCreditOffer = computed(() => this.offer().productType === 'CREDIT_CARD');
}
